import Swal from 'sweetalert2';
import { loaderActions } from '../../features/Loader/LoaderSlice';
import { SocketActions } from '../../features/Socket/SocketSlice';

import { toast } from 'react-hot-toast';
import API from './../API';

export async function submitMassPOFeedback(lines, action, dispatch, companyId, refresh) {
  let title, message, confirmButtonColor, cancelButtonColor, icon, confirmButtonText;
  if (action === 'reject') {
    title = 'Reject';
    message =
      "Are you sure to do this? once you reject a PO line, You won't be able to revert this!";
    icon = 'warning';
    confirmButtonColor = '#d33';
    cancelButtonColor = '#2ed8b6';
    confirmButtonText = 'Yes, Reject it!';
  } else {
    title = 'Approve';
    message =
      "Are you sure to do this? once you approve a PO line, You won't be able to revert this!";
    icon = 'success';
    confirmButtonColor = '#2ed8b6';
    cancelButtonColor = '#d33';
    confirmButtonText = 'Yes, Approve it!';
  }
  const result = await Swal.fire({
    title,
    text: message,
    icon,
    showCancelButton: true,
    confirmButtonColor,
    cancelButtonColor,
    confirmButtonText,
    cancelButtonText: 'Close'
  });
  if (result.isConfirmed) {
    dispatch(loaderActions.show());
    const data = lines.map((line) => {
      return {
        poLine: {
          companyId,
          documentNo: line.documentNo,
          lineNo: line.lineNo,
          itemNo: line.itemNo
        },
        action
      };
    });
    const res = await API().post(`/purchase-feedback-batch`, data);
    if (res.data && typeof res.data === 'object' && res.data.error) {
      toast.error(res.data.error.message);
    } else if (res.response && res.response.status >= 400) {
      toast.error(res.response.data.message);
    } else if (res.code === 'ERR_NETWORK') {
      toast.error(res.message);
    } else {
      toast.success(
        `Pending PO lines ${action === 'reject' ? 'rejected' : 'approved'} successfully`
      );
      lines.forEach((line) => {
        dispatch(SocketActions.readNotification(`${line.documentNo}-${line.lineNo}`));
      });
      refresh();
    }
    dispatch(loaderActions.hide());
  }
}
